<div class="flex flex-col gap-3 p-3.5 border-surface-subtle" [class.border-b]="!isLast()">
  <!-- Identity Row -->
  <div class="flex items-center gap-2.5">
    <div class="flex size-8.5 shrink-0 items-center justify-center rounded-full bg-primary-ghost">
      <span class="text-xs font-semibold text-primary">{{ signer().name | initials }}</span>
    </div>
    <div class="flex min-w-0 flex-1 flex-col gap-1">
      <span class="truncate text-sm font-semibold text-ink">{{ signer().name }}</span>
      <span class="truncate text-xs text-ink-muted">{{ signer().email }}</span>
    </div>
    <dss-libs-ui-chip
      class="shrink-0"
      [label]="signerStatusTranslationKeyMapper.get(signer().actionStatus)!"
      [color]="signerVariantMapper.get(signer().actionStatus)!"
    />
  </div>

  <!-- Status Detail Box -->
  @let detailVariant = signerVariantMapper.get(signer().actionStatus); @let boxVariant = detailVariant === 'warning' &&
  !signer().actionDate ? undefined : detailVariant; @if (boxVariant) {
  <dss-libs-feature-signer-status-box
    [variant]="boxVariant!"
    [actionDate]="signer().actionDate"
    [ipAddress]="signer().ipAddress"
    [expiryDate]="expiryDate()"
    [daysRemaining]="daysRemaining()"
  />
  }

  <!-- Send Reminder Button -->
  @if (detailVariant === 'warning' && canSendReminder()) {
  <dss-libs-ui-button
    class="w-full"
    color="gray"
    variant="outline"
    label="ORDER-DETAILS.ORDER-OPTIONS.SEND-REMINDER"
    [isProcessing]="sendingReminderForId() === signer().id"
    [disabled]="sendingReminderForId() === signer().id"
    [appliedClasses]="
      'flex w-full cursor-pointer items-center justify-center gap-2 rounded-md border border-stroke-soft bg-white! px-1.5 py-1.5 text-xs! font-medium text-ink! transition-colors hover:bg-surface-subtle disabled:cursor-not-allowed disabled:opacity-50'
    "
    (clickOutput)="sendReminder.emit(signer().id)"
  />
  }
</div>
